<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent icono-titulo="fas fa-trophy" texto-titulo="Nuevo objetivo"></TituloComponent>
    <div class="main-card mb-3 card col-12">
      <div class="card-body">
        <form @submit.prevent="guardarObjetivo()">
          <ul class="list-group list-group-flush mb-3" v-if="objetivo.articulo">
            <li class="list-group-item hoverable">
              <div class="widget-content p-0">
                <div class="widget-content-wrapper row">
                  <div class="widget-content-left col-sm-9 col-12">
                    <h4 class="widget-heading text-primary opacity-10">{{objetivo.articulo.descripcion}}</h4>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div class="grid-menu grid-menu-2col" v-else>
            <div class="no-gutters row">
              <div class="col-12">
                <button
                  class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary opacity-7"
                  @click="modalArticulo= true"
                >
                  <i class="fas fa-boxes btn-icon-wrapper btn-icon-lg mb-3"></i>Seleccionar artículo
                </button>
              </div>
            </div>
          </div>
          <div class="row mt-2" v-if="objetivo.articulo">
            <FloatLabel label="Cantidad:" clase=" col-md-4 col-12">
              <input
                v-model="objetivo.cantidad"
                id="cantidad"
                placeholder="0.00"
                type="number"
                step="0.01"
                class="form-control"
                :class="(enviado && (!$v.objetivo.cantidad.required || !$v.objetivo.cantidad.decimal)) ? 'is-invalid' : ''"
              />
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.objetivo.cantidad.required"
                >Debe ingresar la cantidad</div>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.objetivo.cantidad.decimal"
                >Solo se aceptan números</div>
              </template>
            </FloatLabel>
            <FloatLabel label="Desde:" clase=" col-md-4 col-12">
              <input
                v-model="objetivo.desde"
                id="desde"
                type="date"
                class="form-control"
                :class="(enviado && (!$v.objetivo.desde.required)) ? 'is-invalid' : ''"
              />
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.objetivo.desde.required"
                >Debe ingresar la fecha</div>
              </template>
            </FloatLabel>
            <FloatLabel label="Hasta:" clase=" col-md-4 col-12">
              <input
                v-model="objetivo.hasta"
                id="hasta"
                type="date"
                class="form-control"
                :class="(enviado && (!$v.objetivo.hasta.required)) ? 'is-invalid' : ''"
              />
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.objetivo.hasta.required"
                >Debe ingresar la fecha</div>
              </template>
            </FloatLabel>
          </div>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
    <ModalSelectArticulo
      v-if="modalArticulo"
      @selectArticulo="onSelectArticulo"
      @cerrarModalArticulo="modalArticulo = false"
    ></ModalSelectArticulo>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import ModalSelectArticulo from "@/components/views/articulos/ModalSelectArticulo";
import BlockUI from "@/components/loaders/BlockUI";
import { required, decimal } from "vuelidate/lib/validators";
import FloatLabel from "@/components/layouts/FloatLabel";
import axios from "axios";
import Swal from "sweetalert2";
import Objetivo from "@/models/objetivo";
export default {
  name: "NuevoObjetivo",
  components: {
    TituloComponent,
    BlockUI,
    ModalSelectArticulo,
    FloatLabel
  },
  data() {
    return {
      objetivo: new Objetivo(null, null, null, null, null, null, null),
      loading: false,
      enviado: false,
      modalArticulo : false
    };
  },
  validations: {
    objetivo: {
      cantidad: { required, decimal },
      desde: { required },
      hasta: { required }
    }
  },
  methods: {
    guardarObjetivo() {
      this.enviado = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      axios
        .post("/objetivos", this.objetivo)
        .then(res => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `El objetivo se guardó con éxito.`
            });
            this.$router.push({ name: "ListarObjetivos" });
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`
          });
        })
        .finally(() => (this.loading = false));
    },
    onSelectArticulo(articulo) {
      this.objetivo.articulo = articulo;
      this.objetivo.articulo_id = articulo.id;
    },
  }
};
</script>
